export default __webpack_public_path__ + "static/media/3679-vera.33478767.pdf";